import uploadSizes from 'helpers/enums/uploadSizes'
import userRoleTypes from 'helpers/enums/userRoleTypes'

export const maxUploadSizesByRole = userRole => {
	switch (userRole) {
		case userRoleTypes.SUPPORT_CONTENT:
			return uploadSizes.MAX_UPLOAD_VIDEO_SIZE_SUPPORT_CONTENT_USER
		default:
			return uploadSizes.MAX_UPLOAD_VIDEO_SIZE_REGULAR_USER
	}
}

export const validateUploadSize = (size, userRole) => {
	const maxSizeByRole = maxUploadSizesByRole(userRole)
	const maxValidSize = maxSizeByRole * 1048576 // maxSizeByRole * 1048576 bytes (1 megabyte)
	return (size <= maxValidSize && size >= 0)
}
